module.exports = __webpack_public_path__ + "img/point_of.ac3ecdb9.svg";